import {createAction, props} from '@ngrx/store';
import {ApiNotificationListResponseDto, ApiNotificationResponseDto,} from '@birco/rainmesh-api';
import {NotificationFilter} from './notification.state';
import {WsNotificationDto} from '../../../core/models/interfaces/ws-notification-dto.interface';
import { de } from 'date-fns/locale';

const ACTION_PREFIX = '[Notification]';

export const NotificationActions = {
  public: {
    updateNotificationFilter: createAction(
      `${ACTION_PREFIX} updateNotificationFilter`,
      props<{
        filter: NotificationFilter
      }>(),
    ),

    loadLatestNotifications: createAction(
      `${ACTION_PREFIX} loadLatestNotifications`,
    ),

    loadUnreadErrorNotifications: createAction(
      `${ACTION_PREFIX} loadUnreadErrorNotifications`,
    ),

    markAsRead: createAction(
      `${ACTION_PREFIX} markAsRead`,
      props<{
        id: string,
      }>(),
    ),

    markAllAsRead: createAction(
      `${ACTION_PREFIX} markAllAsRead`,
    ),

    deleteAll: createAction(
      `${ACTION_PREFIX} deleteAll`,
    ),

    refreshNotificationDataFromWebSocket: createAction(
      `${ACTION_PREFIX} refreshNotificationDataFromWebSocket`,
      props<{
        notification: WsNotificationDto,
      }>(),
    )
  },

  private: {
    updateUnreadCount: createAction(
      `${ACTION_PREFIX} updateUnreadCount`,
      props<{
        unreadCount: number,
      }>(),
    ),

    loadNotificationsWithFilters: createAction(
      `${ACTION_PREFIX} loadNotificationsWithFilters`,
    ),

    loadNotificationsSuccess: createAction(
      `${ACTION_PREFIX} loadNotificationsSuccess`,
      props<{
        notificationsResponseDto: ApiNotificationListResponseDto
      }>(),
    ),

    loadNotificationsFailure: createAction(
      `${ACTION_PREFIX} loadNotificationsFailure`,
      props<{
        error: any
      }>(),
    ),

    markAsReadSuccess: createAction(
      `${ACTION_PREFIX} markAsReadSuccess`,
      props<{
        responseDto: ApiNotificationResponseDto,
      }>(),
    ),

    markAsReadFailure: createAction(
      `${ACTION_PREFIX} markAsReadFailure`,
      props<{
        id: string,
        error: any,
      }>(),
    ),

    markAllAsReadSuccess: createAction(
      `${ACTION_PREFIX} markAllAsReadSuccess`,
    ),

    markAllAsReadFailure: createAction(
      `${ACTION_PREFIX} markAllAsReadFailure`,
      props<{
        error: any,
      }>(),
    ),

    deleteAllSuccess: createAction(
      `${ACTION_PREFIX} deleteAllSuccess`,
    ),

    deleteAllFailure: createAction(
      `${ACTION_PREFIX} deleteAllFailure`,
      props<{
        error: any,
      }>(),
    ),

    loadNotificationsWithProvidedFiltersSuccess: createAction(
      `${ACTION_PREFIX} loadNotificationsWithProvidedFiltersSuccess`,
      props<{
        responseDto: ApiNotificationListResponseDto,
        updateUnreadCount?: boolean,
        knownNotificationIds?: string[],
        websocketNotificationId?: string,
      }>(),
    ),

    loadNotificationsWithProvidedFiltersFailure: createAction(
      `${ACTION_PREFIX} loadNotificationsWithProvidedFiltersFailure`,
      props<{
        error: any,
      }>(),
    )
  }
}
